import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { setPageTitle } from '../redux/slice/pageTitleSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { allCrudNames, allPages, checkPageAccess } from '../../lib/AllPageNames'
import NotFound from '../NotFound/NotFound'
import IMGSTList from './IMGST/IMGSTList'
import IMWarehouseList from './IMWarehouse/IMWarehouseList'
import { isInventoryModel } from '../../lib/AllStaticVariables'

const InventoryModelTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('gst')
  const dispatch = useDispatch()
  const { pageAccess } = useSelector((state) => state?.user)

  useEffect(() => {
    dispatch(setPageTitle('Manage Warehouse'))
  }, [])

  return checkPageAccess(
    pageAccess,
    allPages?.manageSeller,
    allCrudNames?.read
  ) ? (
    <>
      {checkPageAccess(
        pageAccess,
        allPages?.manageSeller,
        allCrudNames?.read
      ) &&
        isInventoryModel && (
          <div className='card'>
            <div className='card-body p-0'>
              <div className='nav-tabs-horizontal nav nav-tabs'>
                <Link
                  onClick={() => setActiveToggle('gst')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'gst' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Manage GST
                    <hr />
                  </span>
                </Link>
                <Link
                  onClick={() => setActiveToggle('warehouse')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'warehouse' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Manage Warehouse
                    <hr />
                  </span>
                </Link>
              </div>

              <div className='tab-content p-3'>
                <div
                  id='gst'
                  className={`tab-pane fade ${
                    activeToggle === 'gst' ? 'active show' : ''
                  }`}
                >
                  {activeToggle === 'gst' && <IMGSTList />}
                </div>
                <div
                  id='warehouse'
                  className={`tab-pane fade ${
                    activeToggle === 'warehouse' ? 'active show' : ''
                  }`}
                >
                  {activeToggle === 'warehouse' && <IMWarehouseList />}
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  ) : (
    <NotFound />
  )
}

export default InventoryModelTabbing
